export default __webpack_public_path__ + "static/media/architecture-5.746481fa.webp";